import React from "react";
import { CheckCircle2, ArrowRight, ShieldCheck, Truck, Globe, Award } from "lucide-react";
import deliveryImg from "./Images/aboutbanner.jpg";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const AboutSection = () => {
  const features = [
    { text: "ISO & CE Certified", icon: <ShieldCheck size={16} /> },
    { text: "Premium Quality", icon: <Award size={16} /> },
    { text: "Fastest Delivery", icon: <Truck size={16} /> },
    { text: "Pan-India Service", icon: <Globe size={16} /> },
  ];

  return (
    <section className="bg-gray-100 py-20 px-6 lg:px-16">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-16 lg:gap-24">
        
        {/* LEFT */}
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex-1 space-y-6"
        >
          
          {/* Badge */}
          <div className="flex items-center gap-2">
            <span className="h-px w-8 bg-yellow-500"></span>
            <span className="text-yellow-500 font-semibold tracking-widest uppercase text-xs">
              Our Story
            </span>
          </div>

          {/* Heading */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 leading-tight tracking-tight">
            Wholesale Wins, <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-400">
              Delivered Daily.
            </span>
          </h2>

          {/* Description */}
          <p className="text-gray-600 text-base leading-relaxed max-w-lg">
            At Daily Go Live, we bridge the gap between premium manufacturers and your business. 
            We don’t just move products — we streamline your supply chain with efficiency, 
            transparency, and unmatched reliability.
          </p>

          {/* Features */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
            {features.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center gap-3 p-3 rounded-xl border bg-white border-gray-200 hover:shadow-md transition"
              >
                <div className="text-yellow-500 bg-yellow-100 p-2 rounded-lg">
                  {item.icon}
                </div>
                <span className="font-medium text-gray-800 text-sm">{item.text}</span>
              </motion.div>
            ))}
          </div>

          {/* CTA */}
          <div className="pt-4">
            <Link
              to="/AboutUsIndex"
              className="inline-flex items-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-black px-6 py-2.5 rounded-full text-xs font-bold uppercase tracking-wider transition-all hover:translate-x-1 shadow-sm"
            >
              Read More <ArrowRight size={14} />
            </Link>
          </div>
        </motion.div>

        {/* RIGHT */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex-1 relative flex justify-center items-center"
        >
          <div className="relative w-full max-w-md">
            
            {/* Image */}
            <div className="relative overflow-hidden rounded-2xl border border-gray-200 shadow-lg">
              <img
                src={deliveryImg}
                alt="Daily Go Operations"
                className="w-full h-auto object-cover hover:scale-105 transition duration-700"
              />
            </div>

            {/* Badge 1 */}
            <motion.div 
              animate={{ y: [0, -8, 0] }}
              transition={{ duration: 4, repeat: Infinity }}
              className="absolute -bottom-5 -right-5 bg-white border border-gray-200 p-3 rounded-lg shadow-md flex items-center gap-3"
            >
              <div className="bg-green-100 p-2 rounded-md text-green-600">
                <CheckCircle2 size={18} />
              </div>
              <div>
                <p className="text-[10px] text-gray-500 uppercase font-bold">Success Rate</p>
                <p className="text-sm font-bold text-gray-900">99.8%</p>
              </div>
            </motion.div>

            {/* Badge 2 */}
            <motion.div 
              animate={{ y: [0, 8, 0] }}
              transition={{ duration: 5, repeat: Infinity }}
              className="absolute -top-4 -left-4 bg-yellow-500 text-black px-4 py-3 rounded-lg shadow-md"
            >
              <span className="block text-xl font-black">24/7</span>
              <span className="text-[10px] font-bold uppercase">Support</span>
            </motion.div>

          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default AboutSection;